// Firebase config — نفس بيانات المشروع الأصلي
export const firebaseConfig = {
  apiKey: 'AIzaSyB-pXUQSnXAyrdNSaXKZQAQMpzLk2RDIsg',
  authDomain: 'payroll-41699.firebaseapp.com',
  projectId: 'payroll-41699',
  storageBucket: 'payroll-41699.firebasestorage.app',
  messagingSenderId: '777475077217',
  appId: '1:777475077217:web:29bcca1b921ea3b8102620',
};
